import { getCurrencyMinorUnitExponent } from './getCurrencyMinorUnitExponent';

export function isZeroDecimalCurrency(currency: string): boolean {
	return getCurrencyMinorUnitExponent(currency) === 0;
}
